var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommHappyReaction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2029 33C26.3156 33 33.7029 25.6127 33.7029 16.5C33.7029 7.3873 26.3156 0 17.2029 0C8.09018 0 0.702881 7.3873 0.702881 16.5C0.702881 25.6127 8.09018 33 17.2029 33Z",
    fill: "#FFDA24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7718 14.8494H23.6347C24.6209 14.8494 25.4214 15.6499 25.4214 16.636V16.6676C25.4214 21.1857 21.7534 24.8538 17.2352 24.8538H17.2036C12.668 24.8538 8.98584 21.1716 8.98584 16.636C8.98584 15.6499 9.78635 14.8494 10.7725 14.8494H10.7718Z",
    fill: "#473535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.282 23.1137C20.8911 24.2036 19.1393 24.8539 17.2347 24.8539H17.2031C15.2895 24.8539 13.5293 24.2004 12.1326 23.1034C13.2792 21.55 15.1238 20.542 17.2031 20.542C19.2824 20.542 21.1354 21.5539 22.282 23.1137Z",
    fill: "#FF7E27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5276 15.0892V15.5642C24.5276 16.7476 23.5679 17.7079 22.3839 17.7079H12.0224C10.8384 17.7079 9.87866 16.7476 9.87866 15.5642V15.0892C10.1416 14.9371 10.4465 14.8501 10.772 14.8501H23.6349C23.9597 14.8501 24.2652 14.9371 24.5282 15.0892H24.5276Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0339 10.9024C19.8309 10.9024 19.626 10.8476 19.4403 10.7329C18.9105 10.4048 18.7481 9.7087 19.0755 9.1789C19.2444 8.90626 20.788 6.5144 22.9852 6.5144C25.1825 6.5144 26.7261 8.90626 26.895 9.1789C27.223 9.7087 27.0593 10.4035 26.5295 10.7316C26.0004 11.059 25.3069 10.8966 24.9788 10.3687C24.6514 9.84663 23.7335 8.76962 22.9859 8.76962C22.2382 8.76962 21.3204 9.84663 20.993 10.3687C20.7797 10.7129 20.4116 10.9024 20.0346 10.9024H20.0339Z",
    fill: "#473535"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46973 10.9024C8.2667 10.9024 8.06174 10.8476 7.87612 10.7329C7.34631 10.4048 7.18389 9.7087 7.51131 9.1789C7.68018 8.90626 9.22383 6.5144 11.421 6.5144C13.6182 6.5144 15.1619 8.90626 15.3308 9.1789C15.6588 9.7087 15.4951 10.4035 14.9653 10.7316C14.4355 11.0596 13.7407 10.8959 13.4126 10.3661C13.0872 9.84727 12.1693 8.77026 11.4217 8.77026C10.674 8.77026 9.75621 9.84727 9.42879 10.3693C9.21545 10.7135 8.84742 10.903 8.47037 10.903L8.46973 10.9024Z",
    fill: "#473535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommHappyReaction);
export default __webpack_public_path__ + "static/media/comm_happy_reaction.b53ca33f948c64ed346223f5c679915b.svg";
export { ForwardRef as ReactComponent };